import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getBlocks } from '../../actions/contentActions';
import { getIdOrSlugFromPath } from '../../modules/content/utilities';

class TagCloudBlock extends Component {
  componentDidMount = () => {
    this.props.loadBlocks(this.props.contentId);
  }

  render = () => {
    const { content } = this.props;

    return (
      <div className="tag-cloud">
        {content && content.attributes.category.map(option => (
          <div key={option.name} className="badge badge-default mr-2">
            {option.name}
          </div>
        ))}
      </div>
    );
  }
}

TagCloudBlock.propTypes = {
  loadBlocks: PropTypes.func.isRequired,
  content: PropTypes.object,
  contentId: PropTypes.number,
};

const mapState = (state, ownProps) => {
  // The passed identifier can be either the ID or the Slug (string).
  let contentId = Object.keys(state.content).find(i => i === getIdOrSlugFromPath(ownProps.contentId) || state.content[i].slug === getIdOrSlugFromPath(ownProps.contentId));
  if (!contentId && !ownProps.isFetching) {
    contentId = Object.keys(state.content).find(i => state.content[i].slug === '404');
  }

  const content = state.content[contentId];

  return {
    content,
    entities: state.entities.blocks,
    children: (content) ? content.blocks.map(id => state.entities.blocks[id]).filter(b => b.parentId === undefined) : [],
    isFetching: (content) ? content.isFetching : true,
    // options: Object.keys(state.entities.options)
    //   .filter(o => state.entities.options[o].attribute.name === ownProps.properties.attribute.split('.')[1])
    //   .map(o => state.entities.options[o]),
  };
};

const mapDispatch = dispatch => ({
  loadBlocks: id => dispatch(getBlocks(id))
});

export default connect(
  mapState,
  mapDispatch
)(TagCloudBlock);
